// extracted by mini-css-extract-plugin
module.exports = {"closeSection":"CloseSection_closeSection__OQ3_6"};